import { DefaultButton, FlexStack } from '~/components/atomic';
import { Input } from '~/components/atomic';
import * as S from './BottomSheetInner.styled';

interface BottomSheetInnerProps {
  title: string;
  desc: string;
  placeholder: string;
  text: string;
  setText: (text: string) => void;
  disabled: boolean;
  onClick: () => void;
  maxText?: number;
}

export default function BottomSheetInner({
  title,
  desc,
  placeholder,
  text,
  setText,
  disabled,
  onClick,
  maxText = 20,
}: BottomSheetInnerProps) {
  return (
    <S.Container>
      <FlexStack>
        <S.TitleBox>
          <strong>{title}</strong>
        </S.TitleBox>
        <S.DescBox>
          <p>{desc}</p>
        </S.DescBox>
      </FlexStack>
      <S.FormWrapper>
        <Input
          id='MypageChangeNickName'
          placeholder={placeholder}
          text={text}
          setText={setText}
          textLengthOpt
          maxText={maxText}
          inputWrapperName='sheet-inner'
        />
        <div>
          <DefaultButton disabled={disabled} onClick={onClick}>
            Save
          </DefaultButton>
        </div>
      </S.FormWrapper>
    </S.Container>
  );
}
